import React from 'react';
import sunRise from '../assets/sun-rise.png';
import drone from '../assets/drone.png';
import flagImage from '../assets/american-flag.png';

export const WhyChooseUs = () => (
  <section className="py-16 bg-slate-950">
    <div className="max-w-6xl mx-auto px-4">
      <h2 className="text-3xl font-bold text-white mb-8 text-center">Why Choose Us?</h2>
      <div className="grid md:grid-cols-3 gap-6">
        <div className="relative rounded-lg shadow-lg overflow-hidden h-64 bg-cover bg-center" style={{ backgroundImage: `url(${sunRise})` }}>
          <div className="absolute inset-0 bg-slate-800/40 flex flex-col justify-center items-center p-6 text-center">
            <div className="text-sky-400 text-3xl mb-3"><i className="fa-solid fa-camera" /></div>
            <h3 className="font-bold text-white text-xl mb-2">4K Quality</h3>
            <p className="text-sm text-slate-300">Aerial photography and video in stunning 4K resolution.</p>
          </div>
        </div>
        <div className="relative rounded-lg shadow-lg overflow-hidden h-64 bg-cover bg-center" style={{ backgroundImage: `url(${drone})` }}>
          <div className="absolute inset-0 bg-slate-800/40 flex flex-col justify-center items-center p-6 text-center">
            <div className="text-sky-400 text-3xl mb-3"><i className="fa-solid fa-clock" /></div>
            <h3 className="font-bold text-white text-xl mb-2">Fast Turnaround</h3>
            <p className="text-sm text-slate-300">Edited delivery is within 24-48 hours of shoot.</p>
          </div>
        </div>
        <div className="relative rounded-lg shadow-lg overflow-hidden h-64 bg-cover bg-center" style={{ backgroundImage: `url(${flagImage})` }}>
          <div className="absolute inset-0 bg-slate-800/50 flex flex-col justify-center items-center p-6 text-center">
            <div className="text-sky-400 text-3xl mb-3"><i className="fa-solid fa-certificate" /></div>
            <h3 className="font-bold text-white text-xl mb-2">Veteran Owned and FAA Certified</h3>
            <p className="text-sm text-slate-300">FAA Part 107 certified pilot with full liability insurance.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);
